import { LEGACY_BASE_PATH } from '../Constants/LegacyEnvironmentConstants'

const getIsLegacyEnvironment = (): boolean => window.location.href.includes(LEGACY_BASE_PATH)

export default getIsLegacyEnvironment
